import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    marginBottom: toRem(60),

    [theme.breakpoints.up('xl')]: {
        marginBottom: 0
    },

    '& .BoatPrice': {
        paddingBottom: toRem(10),
        borderBottom: `2px solid ${theme.colors.goldDark}`,
        fontSize: toRem(22),
        fontWeight: 700,

        '.price': {
            display: 'flex',
            flexDirection: 'row',
            gap: toRem(12)
        },

        '.vat': {
            display: 'block',
            color: theme.colors.goldDark,
            fontSize: toRem(12),
            textTransform: 'uppercase',
            fontWeight: 500
        },

        [theme.breakpoints.up('md')]: {
            paddingBottom: 0,
            borderBottom: 'none',
            fontSize: toRem(24),
            fontWeight: theme.typography.fontWeight.medium
        }
    },
    '& .FeaturesList': {
        listStyle: 'none',
        display: 'none',
        margin: '20px 0',

        [theme.breakpoints.up('xl')]: {
            display: 'flex'
        },

        '& li': {
            paddingRight: toRem(40),
            '& span': {
                display: 'block',
                color: theme.colors.goldDark,
                fontSize: toRem(14)
            }
        }
    }
})

export default style
